export default __webpack_public_path__ + "static/media/043-monkey.2035f854.svg";